import ClayTabs from "@clayui/tabs";
import React, { useState } from "react";

import NetworkSearchForm from "./NetworkSearchForm";
import ProviderNetworkSearchForm from "./ProviderNetworkSearchForm";
import { t } from "i18next";

const FormsTab = () => {
  const [activeTabKeyValue, setActiveTabKeyValue] = useState(0);

  return (
    <>
      <div className="btn-group pull-right">
        <ClayTabs modern>
          <ClayTabs.Item
            active={activeTabKeyValue === 0}
            innerProps={{
              "aria-controls": "tabpanel-1",
            }}
            onClick={() => setActiveTabKeyValue(0)}
            className={`tab-item ${activeTabKeyValue === 0 ? "active" : ""}`}
          >
            {t("argus-network-search")}

          </ClayTabs.Item>
        </ClayTabs>
        <ClayTabs modern>
          <ClayTabs.Item
            active={activeTabKeyValue === 1}
            innerProps={{
              "aria-controls": "tabpanel-2",
            }}
            onClick={() => setActiveTabKeyValue(1)}
            className={`tab-item ${activeTabKeyValue === 1 ? "active" : ""}`}
          >
            {t("argus-preferred-provider-network-search")}

          </ClayTabs.Item>
        </ClayTabs>
      </div>
      <div className="tab-content">
        <div className="col-md-12 col-sm-12 banner-upper-bg">
          {activeTabKeyValue === 0 && <NetworkSearchForm />}
          {activeTabKeyValue === 1 && <ProviderNetworkSearchForm />}
        </div>
      </div>
    </>
  );
};

export default FormsTab;
